import {Alert} from "react-bootstrap";
export function ErrorPage(){
    return (
        <Alert variant="danger">
            Something has gone wrong.
        </Alert>
    );
}